import axios from 'axios';
import { refreshAccessToken } from 'services/clients/RefreshTokenClient';
import { IRestClient, RestClient } from 'services/clients/RestClient';
import {
  GetVendorRequest,
  ILinkGoogleResponse,
  ILoginResponse,
  ILoginVerifyRequest,
  ILoginWithPhoneRequest,
  IRequestHeader,
  ISignUpRequest,
  IVendorResponse,
  LoggedInData,
  OTPRequest,
  OTPResponse,
  SignUpVerifyRequest,
} from 'services/driverPortal/AuthenticationService.interface';

const baseURL = process.env.REACT_APP_VMP_URL || '';
const apiKey = process.env.REACT_APP_DRIVER_PORTAL_API_KEY || '';
const projectId = process.env.REACT_APP_DRIVER_PORTAL_ALL_NOW_PROJECT_ID || '';
const companyId = process.env.REACT_APP_DRIVER_PORTAL_ALL_NOW_COMPANY_ID || '';

export class AuthenticationService {
  private restClient: IRestClient;
  private accessTokenName = 'driver-portal-access-token';
  private refreshTokenName = 'driver-portal-refresh-token';
  private googleLinkedName = 'driver-portal-google-linked';
  private tel = 'driver-portal-user-tel';
  private userId = 'driver-portal-user-id';
  private potentialLeadId = 'driver-portal-potential-lead-id';
  private profile = 'driver-portal-profile';
  private sub = 'sub';

  constructor() {
    this.restClient = new RestClient({
      baseURL,
    });
  }

  private getToken(name: string) {
    const token = localStorage.getItem(name);
    return token;
  }

  private setToken(name: string, token: string) {
    localStorage.setItem(name, token);
  }

  private removeToken(name: string) {
    localStorage.removeItem(name);
  }

  private setTokenIfValue(name: string, token?: string | number | null) {
    if (token === undefined || token === null || token === '') return;
    this.setToken(name, String(token));
  }

  private buildRequestHeaders(req: IRequestHeader) {
    return {
      'x-api-key': req?.apiKey,
      'project-id': req?.projectId,
      'company-id': req?.companyId,
      'id-token': req?.idToken,
    };
  }

  getUserToken() {
    return {
      accessToken: 'cookie-session',
      userTel: this.getToken(this.tel) || '',
      name: this.getToken(this.profile) || '',
      userId: this.getToken(this.userId) || '',
      potentialLeadId: this.getToken(this.potentialLeadId) || '',
    };
  }

  setUserSessionMetadata(data: {
    userId?: string | number | null;
    potentialLeadId?: string | number | null;
    userTel?: string | number | null;
    name?: string | null;
  }) {
    this.setTokenIfValue(this.tel, data.userTel);
    this.setTokenIfValue(this.profile, data.name);
    this.setTokenIfValue(this.userId, data.userId);
    this.setTokenIfValue(this.potentialLeadId, data.potentialLeadId);
  }

  getUserId() {
    return this.getToken(this.userId);
  }

  getAccessToken() {
    return null;
  }

  hasAccessToken() {
    return true;
  }

  async hasActiveSession() {
    try {
      await refreshAccessToken(baseURL);
      return true;
    } catch {
      return false;
    }
  }

  hasGoogleLinked() {
    return Boolean(this.getToken(this.googleLinkedName));
  }

  // async login<T = ILoginWithPhoneRequest>(request: T) {
  //   const path = '/v1/ondemand/drivers/login';
  //   const response = await this.restClient.post<ILoginResponse>(path, {
  //     data: request,
  //     headers: this.buildRequestHeaders({ apiKey }),
  //   });
  //
  //   //set access token
  //   const { token, refreshToken, googleId, userId } = response?.data;
  //   this.setToken(this.accessTokenName, token);
  //   this.setToken(this.userId, userId);
  //   this.setToken(this.refreshTokenName, refreshToken);
  //   googleId && this.setToken(this.googleLinkedName, 'LINKED');
  //   return response;
  // }

  async login(request: ILoginWithPhoneRequest) {
    // const path = '/open-api/rideILoginWithPhoneRequestr/login';
    const path = 'https://dev-vmp.allnowgroup.com/open-api/rider/login';
    const response = await this.restClient.post<ILoginResponse>(path, {
      data: {
        tel: request.phone,
      },
      // headers: this.buildRequestHeaders({ apiKey }),
    });

    //set access token
    const { userId } = response?.data;
    this.setToken(this.userId, userId);
    return response;
  }

  async loginVerify(request: ILoginVerifyRequest) {
    const path = '/open-api/rider/login';

    return this.restClient.post<OTPResponse>(path, {
      data: {
        tel: request.phone,
      },
    });
  }

  async otpVerify(request: ISignUpRequest) {
    const path = '/open-api/rider/check-otp';

    const response = await this.restClient.post<LoggedInData>(path, {
      data: {
        tel: request.phone,
        otp: request.otpCode,
      },
    });

    const { userId, potentialLeadId } = response;
    this.setToken(this.userId, userId);
    this.setToken(this.potentialLeadId, potentialLeadId);
    this.setToken(this.tel, request.phone);

    return response;
  }

  // async signupVerify(request: SignUpVerifyRequest) {
  //   const path = '/open-api/rider/register';
  //   // const path = 'https://dev-vmp.allnowgroup.com/open-api/rider/register';
  //   return this.restClient.post<OTPResponse>(path, {
  //     data: request,
  //   });
  // }

  async signupVerify(request: SignUpVerifyRequest, sub?: string) {
    let path = '/open-api/rider/register';
    if (sub) path += `?sub=${encodeURIComponent(sub)}`;
    return this.restClient.post<OTPResponse>(path, { data: request });
  }

  async vendorVerify(request: GetVendorRequest) {
    const path = '/v1/ondemand/drivers/vendor';
    try {
      const response = await this.restClient.post<IVendorResponse>(path, {
        data: request,
        headers: this.buildRequestHeaders({
          apiKey,
          companyId,
          projectId,
        }),
      });

      return response;
    } catch (error) {
      return null;
    }
  }

  // async logout() {
  //   try {
  //     const path = '/v1/ondemand/drivers/logout';
  //     const response = await this.restClient.post<IOTPResponse>(path, {
  //       headers: this.buildRequestHeaders({
  //         apiKey,
  //         authorization: this.getToken(this.accessTokenName),
  //       }),
  //     });
  //     return response;
  //   } catch (error) {
  //   } finally {
  //     // remove tokens
  //     this.removeToken(this.accessTokenName);
  //     this.removeToken(this.refreshTokenName);
  //     this.removeToken(this.googleLinkedName);
  //     this.removeToken(this.userId);
  //     this.removeToken(this.potentialLeadId);
  //   }
  // }

  async logout(): Promise<void> {
    try {
      await this.restClient.post('/open-api/auth/logout', {});
    } catch {
    } finally {
      this.removeToken(this.accessTokenName);
      this.removeToken(this.refreshTokenName);
      this.removeToken(this.googleLinkedName);
      this.removeToken(this.userId);
      this.removeToken(this.potentialLeadId);
      this.removeToken(this.sub);
      this.removeToken(this.tel);
      this.removeToken(this.profile);
    }
  }

  async requestOTP(request: OTPRequest) {
    const path = '/open-api/rider/resend-otp';
    // const path = 'https://dev-vmp.allnowgroup.com/open-api/rider/resend-otp';
    return this.restClient.post<OTPResponse>(path, {
      data: {
        tel: request.phone,
      },
    });
  }

  async linkGoogle(idToken: string) {
    const path = '/v1/ondemand/drivers/google/link';
    const response = await this.restClient.post<ILinkGoogleResponse>(path, {
      headers: this.buildRequestHeaders({
        apiKey,
        idToken,
      }),
    });

    const { googleId } = response?.data;
    googleId && this.setToken(this.googleLinkedName, 'LINKED');

    return response;
  }

  async revokeGoogle(accessToken: string) {
    const path = 'https://accounts.google.com/o/oauth2/revoke';
    return await axios.post(path, {
      token: accessToken,
    });
  }
}
